import { render, staticRenderFns } from "./VxTextarea.vue?vue&type=template&id=4ce08a1d&"
import script from "./VxTextarea.vue?vue&type=script&lang=js&"
export * from "./VxTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports